import { createFileRoute } from "@tanstack/react-router";
import { DiscoveryPage } from "@/components/DiscoveryPage";
import { discoverySearchSchema } from "@/lib/discovery-search";

export const Route = createFileRoute("/")({
  // Discovery state lives in the URL, so a search survives a refresh, the back
  // button and being shared with someone else.
  validateSearch: discoverySearchSchema,
  component: DiscoveryPage,
});
